import * as React from "react";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import Button from "@amzn/awsui-components-react/polaris/button";
import PrescriptionDetailsBlock, { MedicationOption, PrescriptionFormState } from "./PrescriptionDetailsBlock";
import SiglineBlock, { SiglineFormState, EMPTY_SIGLINE } from "./SiglineBlock";

export interface PrescriptionEntry {
  prescription: PrescriptionFormState;
  siglines: SiglineFormState[];
}

export const EMPTY_PRESCRIPTION: PrescriptionFormState = {
  drugId: "", drugIdInput: "", initialRefills: "5", quantityAuthorized: "30", daysSupply: "30", dispenseQuantity: "30", dispenseDaysSupply: "30",
};

interface Props {
  entry: PrescriptionEntry;
  medications: MedicationOption[];
  onChange: (updated: PrescriptionEntry) => void;
}

class PrescriptionTabContent extends React.Component<Props> {
  private updatePrescription = (updates: Partial<PrescriptionFormState>) => {
    const { entry, onChange } = this.props;
    const next = { ...entry.prescription, ...updates };
    const updated: PrescriptionEntry = { ...entry, prescription: next };
    if ('inPackets' in updates && updates.inPackets && entry.siglines.length === 0) {
      updated.siglines = [{ ...EMPTY_SIGLINE }];
    }
    onChange(updated);
  };

  private updateSigline = (index: number, updates: Partial<SiglineFormState>) => {
    const { entry, onChange } = this.props;
    const siglines = [...entry.siglines];
    siglines[index] = { ...siglines[index], ...updates };
    onChange({ ...entry, siglines });
  };

  private addSigline = () => {
    const { entry, onChange } = this.props;
    onChange({ ...entry, siglines: [...entry.siglines, { ...EMPTY_SIGLINE }] });
  };

  private removeSigline = (index: number) => {
    const { entry, onChange } = this.props;
    onChange({ ...entry, siglines: entry.siglines.filter((_, i) => i !== index) });
  };

  private resetPrescription = () => {
    const { onChange } = this.props;
    onChange({ prescription: { ...EMPTY_PRESCRIPTION }, siglines: [] });
  };

  render() {
    const { entry, medications } = this.props;

    return (
      <SpaceBetween size="l">
        <PrescriptionDetailsBlock
          prescription={entry.prescription}
          medications={medications}
          onChange={this.updatePrescription}
          onReset={this.resetPrescription}
        />

        {entry.siglines.map((sig, i) => (
          <SiglineBlock
            key={i}
            sigline={sig}
            index={i}
            onChange={(updates) => this.updateSigline(i, updates)}
            onRemove={() => this.removeSigline(i)}
          />
        ))}

        <Button iconName="add-plus" onClick={this.addSigline}>
          Add SIG Line
        </Button>
      </SpaceBetween>
    );
  }
}

export default PrescriptionTabContent;
